import React from 'react';
import { ContextExtensionModule } from '@go-shared/types/go-modules/goModules';
import { ExtensionPointRenderer } from '@go-client/go-modules/core/ExtensionPoints/Renderers';

export class MenuRenderer implements ExtensionPointRenderer {
  render(data: ContextExtensionModule[]): JSX.Element {
    return (
      <>
        {data.map(item => (
          <a href={item.component.url}>{item.name}</a>
        ))}
      </>
    );
  }
}
